// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// applicationSettings is a set of properties that are
// configured in the back end properties and are related
// to application environment settings

// NOTE - it is currently very basic however once external users are needed,
// this slice of state will be necessary for conditional rendering

import applicationSettings from './reducer'
export default applicationSettings

export {
  fetchAndAddApplicationSettings,
} from './thunks'
